import React, { Component } from 'react'
import * as styles from './affiliate.module.css'

export default class Affiliate extends Component {

  render() {
    const afilink = this.props.afilink
    return (
      <div className={styles.afilinlk}>
        <div dangerouslySetInnerHTML={{ __html: afilink }} />
      </div>
    )
  }
}